import React from 'react';
import { Identifier, UserIdentity } from 'react-admin';

export class AdminIdentity implements UserIdentity {
    id: string = "";
    fullName?: string;
    avatar?: string;
    sessionGuid?: string;
    [key: string]: any;
}